/**
 * Model for a CarouselPage, which contains an icon and descriptive text
 */
export class CarouselPage {
  /**
   * @param {string} icon material icon to be displayed
   * @param {string} text descriptive text
   * @constructor
   */
  constructor(public icon: string, public text: string) {}
}
